export default __webpack_public_path__ + "static/media/home-travel-agency-packages-img05.be594d7d.jpg";